var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "查看视频",
        visible: _vm.dialogVisible,
        width: "600px",
        "close-on-click-modal": false,
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _vm.videoList && _vm.videoList.length > 0
        ? _c(
            "div",
            { staticStyle: { height: "400px", "overflow-y": "auto" } },
            _vm._l(_vm.videoList, function (item, index) {
              return _c(
                "div",
                { key: index, staticStyle: { "margin-bottom": "20px" } },
                [
                  _c("video", {
                    staticStyle: { width: "100%" },
                    attrs: { src: item.url || item, controls: "" },
                  }),
                ]
              )
            }),
            0
          )
        : _c(
            "div",
            { staticStyle: { "text-align": "center", padding: "20px" } },
            [_vm._v(" 暂无视频 ")]
          ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v("关闭")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }